import API from './axios';
export class ProductService {
    /* updateproduct(arg0: number, arg1: number, data: any) {
        throw new Error('Method not implemented.');
      }
      createproduct(arg0: number, arg1: number, data: any) {
        throw new Error('Method not implemented.');
      } */

    products(pageNumber: number, size: number, brand: number, categoryid: number): Promise<any> {
        return API.post(`api/index.php`, {
            action: 'getProductList',
            src: 'dashboard',
            brandid: brand,
            categoryid,
            retrievalmode: 'mysql'
        });
    }

    createproduct(prodCatId: number, brandId: number, data: any): Promise<any> {
        //return API.post(`api/index.php`, { 'action': 'setProductData', 'src': 'dashboard', retrievalmode: 'mysql', 'prodCatId':prodCatId, 'brandId':brandId, 'data': [data] });
        return API.post(`api/index.php`, { 'action': 'ProductDataAction', 'src': 'dashboard', retrievalmode: 'mysql', 'prodCatId':prodCatId, 'brandId':brandId, 'data': [data] });
    }

    
    updateproduct(prodCatId: number, brandId: number, data: any, oldBrandId?: number, oldProdCatId?: number): Promise<any> {
        // oldBrandId/oldProdCatId let the backend refresh the OLD category's Redis list when a
        // product is moved to a different brand/sub-category (Issue #1 fix 2026-06-24).
        return API.post(`api/index.php`, { 'action': 'ProductDataActionSingle', 'src': 'dashboard', retrievalmode: 'mysql', 'prodCatId':prodCatId, 'brandId':brandId, 'oldBrandId':oldBrandId, 'oldProdCatId':oldProdCatId, 'data': [data] });
    }

    getProductSizes(brandId:any): Promise<any> {
        return API.post(`api/index.php`, { 'action': 'getProductSize', page: 1, retrievalmode: 'mysql', 
        size: 9999, src: 'dashboard' , "brandId":brandId});
    }

    getProductActiveFinishes(brandId:any): Promise<any> {
        return API.post(`api/index.php`, { 'action': 'getProductFinish', 'status': 1, 'src': 'dashboard', 'retrievalmode': 'mysql',"brandId":brandId });
    }

    getProductAllFinishes(): Promise<any> {
        return API.post(`api/index.php`, { 'action': 'getProductFinish', 'src': 'dashboard', 'retrievalmode': 'mysql' });
    }

    getProductData(brandid: number, modelno: string): Promise<any> {
        return API.post(`api/index.php`, { 'action': 'getProductDetails', 'src': 'dashboard', 'retrievalmode': 'mysql', brandid, modelno });
    }

    getCurrentStock(): Promise<any> {
        return API.post(`api/index.php`, { 'action': 'getCurrentStockList', 'src': 'dashboard', 'retrievalmode': 'mysql' });
    }
}